/**
 * workforce domain — daily operations map + worker route history (Track A).
 * Read-only. Every call is gated by the DISTINCT `location_history:view`
 * permission on the backend (granted to NO role by default); the backend also
 * writes an audit_event for each reveal. Types mirror the location service's
 * Track A views verbatim (mark for consolidation).
 */
import { get } from './transport.js';
/** Build the access-reason header, preserving any caller-supplied headers. */
function accessReasonHeaders(reason, headers) {
    const trimmed = reason?.trim();
    if (!trimmed)
        return headers;
    return { ...headers, 'x-cwos-access-reason': trimmed };
}
/** `GET /location/workforce/:date` → workforce map (needs `location_history:view`). */
export async function workforceMap(date, query = {}, options) {
    const { reason, tz } = query;
    return get(`/location/workforce/${date}`, {
        ...options,
        query: tz ? { tz } : {},
        headers: accessReasonHeaders(reason, options?.headers),
    });
}
/**
 * `GET /location/sessions/:id/timeline` → route history.
 *
 * Needs BOTH `location_history:view` AND `breadcrumb:view`. The second is not
 * decoration: this route returns `listBreadcrumbsForSession` verbatim — the
 * same polyline `GET /location/sessions/:id/breadcrumbs` serves — plus punches,
 * stops, gaps and coverage. It was gated on `location_history:view` alone,
 * so a caller refused at the narrow door was handed the identical trail with
 * extras one URL over, and `breadcrumb:view` gated nothing that could not be
 * obtained without it. Both doors now go through one predicate on the server.
 *
 * Both keys are granted to NO role by default and are the product's only two
 * default-deny keys, so holding one says nothing about holding the other.
 */
export async function sessionTimeline(sessionId, query = {}, options) {
    return get(`/location/sessions/${sessionId}/timeline`, {
        ...options,
        headers: accessReasonHeaders(query.reason, options?.headers),
    });
}
//# sourceMappingURL=workforce.js.map